module.exports = __webpack_public_path__ + "img/thumbnail_BairdsTapir_j_normal.2cb9b18b.png";